module.exports = __webpack_public_path__ + "img/packet.a5e03a7.svg";